import { Component, ViewEncapsulation, ViewChild, Output, EventEmitter } from '@angular/core';
import { ModalComponent } from '../modal.component/modal.component';
import { Router } from '@angular/router';

@Component({
    selector: 'app-salestop-reached-modal',
    templateUrl: './salestop-reached-modal.component.html',
    styleUrls: ['./salestop-reached-modal.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class SaleStopReachedModalComponent
{
    private readonly router: Router;

    public constructor(
        router: Router
    )
    {
        this.router = router;
    }

    @Output('close')
    public close = new EventEmitter();

    @ViewChild('modal', { static: true })
    public modal: ModalComponent;

    public open(): void
    {
        this.modal.open();
    }

    public onCloseClick(): void
    {
        this.modal.close('closed by click');
        this.router.navigateByUrl('/min-side');
    }
}
